import { ChakraProvider, Container } from "@chakra-ui/react";
import React, { FC } from "react";

import Header from "../../organisms/Header";
import Fonts from "../../../../static/fonts";
import Footer from "../../organisms/Footer";
import Breadcrumbs from "../../organisms/Breadcrumbs";
import { useLocation } from "@reach/router";
import { Helmet } from "react-helmet";
import { ApolloProvider } from "@apollo/client";
import { client } from "../../../../lib/apolloClient";
import { customTheme } from "../../../theme/theme";
import CookieConsent from "../../organisms/CookieConsent";

type RegularLayoutType = {
  children: JSX.Element;
  maxWidth?: string | number;
  isAboutUsScreen?: boolean;
  headerAlwaysVisible?: boolean;
  crumbs?: any;
};

const RegularLayout: FC<RegularLayoutType> = ({
  children,
  maxWidth,
  headerAlwaysVisible,
  crumbs,
}) => {
  const location = useLocation();
  const siteUrl = "https://www.vellis.financial";
  const canonicalUrl = `${siteUrl}${location.pathname}`;
  return (
    <ApolloProvider client={client}>
      <ChakraProvider theme={customTheme}>
        <div
          style={{
            width: "100%",
            background: "#fff",
            position: "relative",
          }}
        >
          <Helmet>
            <html lang="en" />
            <meta charSet="utf-8" />
            <link rel="canonical" href={canonicalUrl} />
            <script
              async
              type="text/javascript"
              src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=RBsi9j"
            ></script>
          </Helmet>
          <Fonts />
          <Header alwaysVisible={headerAlwaysVisible} />

          <Container
            width="100%"
            flex={1}
            maxWidth={maxWidth ?? "1280px"}
            padding={0}
            mx="auto"
            position="relative"
          >
            {crumbs && <Breadcrumbs crumbs={crumbs} />}

            {children}
            <CookieConsent />
          </Container>

          <Footer />
        </div>
      </ChakraProvider>
    </ApolloProvider>
  );
};

export default RegularLayout;
